var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31 36.2h14.1v14.1H31zM78.3 49.9l-7.9-13.4-7.9 13.4z","fill":"none","stroke":"#ee693f","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-ee693f","key":0}),React.createElement("path",{"d":"M10 10h90v55.3H10zM100 23.2H10M30 94l25-28.7V100M80 94 55 65.3","fill":"none","stroke":"#ffffff","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-545454","key":1})]);
}

Video.defaultProps = {"viewBox":"0 0 110 110","xmlSpace":"preserve","enableBackground":"new 0 0 110 110"};

module.exports = Video;

Video.default = Video;
